import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgxResizeObserverService } from 'ngx-resize-observer';

import { ResizeObserverWrapperService } from '@hdms/shared/util-core';

import { FloatingContainerDirective } from './floating-container.directive';
import { FloatingDirective } from './floating.directive';

@NgModule({
  declarations: [FloatingDirective, FloatingContainerDirective],
  imports: [CommonModule],
  exports: [FloatingDirective, FloatingContainerDirective],
  providers: [NgxResizeObserverService, ResizeObserverWrapperService]
})
export class FloatingModule {}

export * from './floating-container.directive';
export * from './floating.directive';
